import { Grid, Typography } from '@material-ui/core';
import { useScrollButtonState } from '@ncr-retail/hooks';
import React from 'react';
import { IElectronicJournalRecord } from '../../../common/interfaces/states/IElectronicJournalRecord';
import Pagination from '../../../pagination/pagination';
import { styles } from './summary-menu-styles';
import { PromotionSummaryList } from './promotion-summary-list';

export const SummaryMenuBase: React.FC<SummaryMenuProps> = ({
  title,
  items,
  totalLabel,
  totalValue,
  testIdPrefix,
}): JSX.Element => {
  const classes = styles();
  const [{ currentPage, lastPage, onPageChanged }, scrollRef] = useScrollButtonState(items.length);

  return (
    <Grid
      container
      direction={'column'}
      className={`fullHeight ${classes.dialogPadding}`}
      justifyContent={'flex-start'}
      data-testid={`${testIdPrefix}-summary-menu`}
    >
      <span className={classes.summaryLabel} data-testid={`${testIdPrefix}-summary-menu-label`}>
        {title} ({items.filter(i => !i.Voided).length})
      </span>
      <Grid item className={`fullWidth ${classes.summaryItemContainer}`}>
        <div
          ref={scrollRef}
          data-testid={`${testIdPrefix}-summary-list-container`}
          className='verticalScroll fullWidth fullHeight'
        >
          <Grid container>
            {items.map((item, index) => {
              return (
                <PromotionSummaryList
                  item={item}
                  index={index}
                  key={`${item.Description}-${item.SequenceNumber}}`}
                />
              );
            })}
          </Grid>
        </div>
      </Grid>
      <Grid className={`fullWidth ${classes.footer}`}>
        <Grid container direction='row' justifyContent='space-between'>
          <Grid item container className={classes.paginationContainer}>
            <Pagination
              currentPage={currentPage}
              totalPages={lastPage}
              updateCurrentPageHandler={onPageChanged}
              testIdPrefix={'promotion-summary'}
            />
          </Grid>
          <Grid
            item
            container
            direction='column'
            xs={6}
            className={`${classes.summaryTextContainer}`}
          >
            <Grid container justifyContent='flex-end'>
              <Typography
                className={classes.promotionSummaryText}
                data-testid={`${testIdPrefix}-summary-menu-total-text`}
              >
                {totalLabel}:
              </Typography>
              <Typography
                className={`${classes.promotionSummaryText} ${classes.totalMargin}`}
                data-testid={`${testIdPrefix}-summary-menu-total`}
              >
                {totalValue}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

interface SummaryMenuProps {
  title: string;
  items: IElectronicJournalRecord[];
  totalLabel: string;
  totalValue: string;
  testIdPrefix: string;
}
